<template>
  <div class="page-modal">
    <!-- Single -->
    <widgetModal
      :title="'Assign LIA'"
      :subtitle="'Search student by name and assign them to the internship'"
      btnlefttext="Assign"
      btncentertext="Cancel"
      btnrighttext=""
      :leftloading="submiting_loading"
      :rightloading="false"
      :centerloading="false"
      :footerhidden="false"
      footer_padding="10px 18px 30px 30px"
      header_padding="30px 0px 0px 31px"
      body_padding="0px 30px"
      width="700px"
      :hiderightbtn="true"
      @onLeftClick="onConfirm()"
      @onCenterClick="onCancel"
      @onRightClick="onRightClick()"
    >
      <div class="widget-modal-body-noscoll">
        <div class="widget-modal-search-widget">
          <widgetInputWrapper title="Assign to:">
            <widgetSearch
              icon="right"
              :loading="loading_searching"
              v-model="search_member_input"
              @keyup="searchCompanyMember()"
              placeholder="Type in to Search…"
            ></widgetSearch>
          </widgetInputWrapper>
          <div class="widget-modal-search-result" v-if="students.length > 0">
            <div
              class="widget-modal-search-item"
              v-for="(item, index) in students"
              :key="index"
              @click="onSelectStudent(item)"
            >
              <widgetProfile
                :title="item.first_name + ' ' + item.last_name"
                :subtitle="item.profile ? item.profile.address : ''"
                :file_name="item.profile_picture"
                :path="$fullUrl('images/profiles/')"
              ></widgetProfile>
            </div>
          </div>
        </div>
        <div class="widget-modal-selected-user">
          <div
            class="widget-selected-item"
            v-for="(item, index) in selected_students"
            :key="index"
          >
            <widgetProfile
              :title="item.first_name + ' ' + item.last_name"
              subtitle=""
              :file_name="item.profile_picture"
              :path="$fullUrl('images/profiles/')"
              :size="20"
              :text_size="8"
            ></widgetProfile>
            <button
              @click="onRemoveSelectedUser(item, index)"
              class="btn-remove"
            >
              &times;
            </button>
          </div>
        </div>
      </div>
    </widgetModal>
  </div>
</template>
<script>
import { eventBus } from "@/main";
export default {
  name: "page-modal",
  props: {
    internship: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      search_member_input: "",
      students: [],
      selected_students: [],
      form: {
        internship_id: null,
        students: [],
      },
      submiting_loading: false,
    };
  },
  computed: {},
  watch: {},
  mounted() {
    let vm = this;
  },
  methods: {
    onRemoveSelectedUser(item, index) {
      let vm = this;
      vm.selected_students.splice(index, 1);
    },
    onSelectStudent(item) {
      let vm = this;
      vm.selected_students.push(item);
      vm.students = [];
      vm.search_member_input = "";
    },
    searchCompanyMember() {
      let vm = this;
      let query = vm.search_member_input;
      if (vm.search_member_input) {
        vm.loading_searching = true;
        vm.$store
          .dispatch("SEARCH_FOR_COMPANY_MEMBERS", { query: query })
          .then((responce) => {
            vm.loading_searching = false;
            vm.students = responce.data;
          })
          .catch((error) => {
            vm.loading_searching = false;
            console.log(error);
          });
      } else {
        vm.students = [];
      }
    },
    onRightClick() {
      let vm = this;
      vm.internship_form.save_type = "many";
    },
    onConfirm() {
      let vm = this;
      const rules = {
        students: {
          run: (value) => {
            if (vm.selected_students.length == 0) {
              return "Please select at least one student";
            }
          },
        },
      };
      if (vm.$isFieldsValidated(vm.form, rules)) {
        vm.form.internship_id = vm.internship.id;
        vm.form.students = vm.selected_students.map((item) => {
          return item.id;
        });
        vm.submiting_loading = true;
        vm.$store
          .dispatch("INTERNSHIP_ASSIGN_INTERNSHIP", vm.form)
          .then((responce) => {
            vm.submiting_loading = false;
            vm.$notify({
              group: "status",
              title: "Message",
              text: "Internship assigned successfully",
              type: "success",
              duration: 3000,
            });
            vm.$emit("success", null);
          })
          .catch((error) => {
            vm.submiting_loading = false;
            vm.$notify({
              group: "status",
              title: "Message",
              text: "Something went wrong, try again",
              type: "warn",
              duration: 3000,
            });
          });
      }
    },
    onCancel() {
      let vm = this;
      vm.$emit("close", null);
    },
  },
};
</script>

<style lang="scss" scoped>
$assets: "~@/assets";
.page-modal {
  .widget-modal-body-noscoll {
    padding: 20px 0px;
    .widget-modal-search-widget {
      position: relative;
      .widget-modal-search-result {
        position: absolute;
        top: 100%;
        left: 0;
        width: 100%;
        background: #fff;
        height: 200px;
        overflow-y: scroll;
        box-shadow: 0px 0px 3px #ddd;
        z-index: 9999;
        .widget-modal-search-item {
          margin-bottom: 10px;
          border-bottom: 1px solid #ddd;
          padding: 10px 10px;
          cursor: pointer;
          &:last-child {
            margin-bottom: 0px;
            border-bottom: none;
          }
          &:hover {
            background: #f5f5f5;
          }
        }
      }
    }
    .widget-modal-selected-user {
      margin-top: 20px;
      display: flex;
      flex-wrap: wrap;
      .widget-selected-item {
        display: flex;
        margin-right: 10px;
        margin-bottom: 10px;
        position: relative;
        background: #d1d1d1;
        border-radius: 20px;
        padding: 5px 10px;

        .btn-remove {
          background: #fff;
          border: 1px solid #ddd;
          border-radius: 50%;
          width: 20px;
          height: 20px;
          display: flex;
          align-items: center;
          justify-content: center;

          cursor: pointer;
          &:hover {
            background: #f5f5f5;
          }
        }
      }
    }
  }
}
</style>